import { render } from "./CategoryFilter.vue?vue&type=template&id=e71b376e&scoped=true"
import script from "./CategoryFilter.vue?vue&type=script&lang=js"
export * from "./CategoryFilter.vue?vue&type=script&lang=js"

import "./CategoryFilter.vue?vue&type=style&index=0&id=e71b376e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e71b376e"]])

export default __exports__